var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-body tenant-settings"},[_vm._v(" 绩效管理（暂时不处理，敬请期待） ")])
}
var staticRenderFns = []

export { render, staticRenderFns }